"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.borrowPerpetual = void 0;
const common_1 = require("../../../../../common");
const constants_1 = require("../../../../constants");
const constants_2 = require("../../../../constants");
const offer_1 = require("../../offer");
const helpers_1 = require("./../../../../helpers");
const anchor_1 = require("@coral-xyz/anchor");
const token_1 = require("@coral-xyz/anchor/dist/cjs/utils/token");
const borrowPerpetual = (_a) => __awaiter(void 0, [_a], void 0, function* ({ programId, connection, args, accounts, sendTxn, }) {
    let accountCreated = {
        fraktBond: constants_1.EMPTY_PUBKEY,
        bondOffer: constants_1.EMPTY_PUBKEY,
        bondTradeTransaction: constants_1.EMPTY_PUBKEY,
        lenderVault: constants_1.EMPTY_PUBKEY,
    };
    const program = (0, helpers_1.returnAnchorProgram)(connection);
    const instructions = [];
    const splTokenMint = (0, offer_1.getTokenMintFromLendingTokenType)(args.lendingTokenType);
    const [mutualBondTradeTxnVault] = anchor_1.web3.PublicKey.findProgramAddressSync([constants_1.ENCODER.encode(constants_2.MUTUAL_BOND_TRADE_TXN_VAULT)], program.programId);
    const perpetualBorrowParamsAndAccountsWithSeeds = args.perpetualBorrowParamsAndAccounts.map((param) => (Object.assign(Object.assign({}, param), { minAmountToGet: Math.floor(Math.random() * 10000) })));
    const perpetualBorrowParams = yield Promise.all(perpetualBorrowParamsAndAccountsWithSeeds.map((perpetualBorrowParamsAndAccount) => __awaiter(void 0, void 0, void 0, function* () {
        const [fbond, fraktBondBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            constants_1.ENCODER.encode(constants_1.FRAKT_BOND_PREFIX),
            perpetualBorrowParamsAndAccount.tokenMint.toBuffer(),
            perpetualBorrowParamsAndAccount.bondOfferV2.toBuffer(),
            constants_1.ENCODER.encode(perpetualBorrowParamsAndAccount.minAmountToGet.toString()),
            constants_1.ENCODER.encode(perpetualBorrowParamsAndAccount.amountOfSolToGet.toString()),
        ], program.programId);
        const [bondTradeTransaction, bondTradeTransactionBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            constants_1.ENCODER.encode(constants_2.AUTOCOMPOUND_DEPOSIT_PREFIX),
            fbond.toBuffer(),
            perpetualBorrowParamsAndAccount.bondOfferV2.toBuffer(),
            constants_1.ENCODER.encode(perpetualBorrowParamsAndAccount.minAmountToGet.toString()),
            constants_1.ENCODER.encode(perpetualBorrowParamsAndAccount.amountOfSolToGet.toString()),
        ], program.programId);
        const [lenderVault, lenderVaultBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
            constants_1.ENCODER.encode(constants_1.USER_VAULT_PREFIX),
            perpetualBorrowParamsAndAccount.lender.toBuffer(),
            splTokenMint.toBuffer()
        ], program.programId);
        accountCreated = {
            fraktBond: fbond,
            bondOffer: perpetualBorrowParamsAndAccount.bondOfferV2,
            bondTradeTransaction: bondTradeTransaction,
            lenderVault,
        };
        return {
            minAmountToGet: new anchor_1.BN(perpetualBorrowParamsAndAccount.minAmountToGet),
            amountOfSolToGet: new anchor_1.BN(perpetualBorrowParamsAndAccount.amountOfSolToGet),
            bondTradeTransactionBump: bondTradeTransactionBump,
            fraktBondBump: fraktBondBump,
            bondOfferVaultBump: lenderVaultBump,
        };
    })));
    const sellBondRemainingAccounts = (yield Promise.all(perpetualBorrowParamsAndAccountsWithSeeds.map((perpetualBorrowParamsAndAccount) => __awaiter(void 0, void 0, void 0, function* () {
        const [fbond] = anchor_1.web3.PublicKey.findProgramAddressSync([
            constants_1.ENCODER.encode(constants_1.FRAKT_BOND_PREFIX),
            perpetualBorrowParamsAndAccount.tokenMint.toBuffer(),
            perpetualBorrowParamsAndAccount.bondOfferV2.toBuffer(),
            constants_1.ENCODER.encode(perpetualBorrowParamsAndAccount.minAmountToGet.toString()),
            constants_1.ENCODER.encode(perpetualBorrowParamsAndAccount.amountOfSolToGet.toString()),
        ], program.programId);
        const [bondTradeTransactionV2] = anchor_1.web3.PublicKey.findProgramAddressSync([
            constants_1.ENCODER.encode(constants_2.AUTOCOMPOUND_DEPOSIT_PREFIX),
            fbond.toBuffer(),
            perpetualBorrowParamsAndAccount.bondOfferV2.toBuffer(),
            constants_1.ENCODER.encode(perpetualBorrowParamsAndAccount.minAmountToGet.toString()),
            constants_1.ENCODER.encode(perpetualBorrowParamsAndAccount.amountOfSolToGet.toString()),
        ], program.programId);
        const tempSplTokenMint = (0, offer_1.getTokenMintFromLendingTokenType)(args.lendingTokenType);
        const [lenderVault, lenderVaultBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
            constants_1.ENCODER.encode(constants_1.USER_VAULT_PREFIX),
            perpetualBorrowParamsAndAccount.lender.toBuffer(),
            splTokenMint.toBuffer()
        ], program.programId);
        const vaultSplTokenAccountUninitialized = yield (0, common_1.findAssociatedTokenAddress)(lenderVault, tempSplTokenMint);
        const userTokenAccount = yield (0, common_1.findAssociatedTokenAddress)(accounts.userPubkey, perpetualBorrowParamsAndAccount.tokenMint);
        const ownerTokenRecord = (0, helpers_1.findTokenRecordPda)(perpetualBorrowParamsAndAccount.tokenMint, userTokenAccount);
        const targetRuleSet = perpetualBorrowParamsAndAccount.ruleSet || accounts.protocolFeeReceiver;
        const targetDelegatePubkey = accounts.protocolFeeReceiver;
        const subRemainingAccounts = [
            {
                pubkey: ownerTokenRecord,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: targetRuleSet,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: targetDelegatePubkey,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: userTokenAccount,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: perpetualBorrowParamsAndAccount.hadoMarket,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: perpetualBorrowParamsAndAccount.bondOfferV2,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: lenderVault,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: vaultSplTokenAccountUninitialized,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: bondTradeTransactionV2,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: fbond,
                isSigner: false,
                isWritable: true,
            },
        ];
        if (perpetualBorrowParamsAndAccount.hadoMarket.toString() == constants_1.BANX_63_POINTS_HADOMARKET_PUBLIC ||
            perpetualBorrowParamsAndAccount.hadoMarket.toString() == constants_1.BANX_63_POINTS_HADOMARKET_PRIVATE) {
            const [banxPointsMap] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_POINTS_MAP_PREFIX), perpetualBorrowParamsAndAccount.tokenMint.toBuffer()], program.programId);
            subRemainingAccounts.push({
                pubkey: banxPointsMap,
                isSigner: false,
                isWritable: true,
            });
        }
        return subRemainingAccounts;
    })))).flat();
    const editionInfo = (0, helpers_1.getMetaplexEditionPda)(perpetualBorrowParamsAndAccountsWithSeeds[0].tokenMint);
    const nftMetadata = (0, helpers_1.getMetaplexMetadata)(perpetualBorrowParamsAndAccountsWithSeeds[0].tokenMint);
    const userSplTokenAccountUninitialized = yield (0, common_1.findAssociatedTokenAddress)(accounts.userPubkey, splTokenMint);
    const protocolFeeReceiverSplTokenAccountUninitialized = yield (0, common_1.findAssociatedTokenAddress)(accounts.protocolFeeReceiver, splTokenMint);
    const [rentVault, rentVaultBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
        constants_1.ENCODER.encode(constants_1.RENT_VAULT),
    ], program.programId);
    const createAndSellBondRemainingAccounts = [...sellBondRemainingAccounts];
    instructions.push(yield program.methods
        .borrowPerpetual(perpetualBorrowParams, args.optimizeIntoReserves, new anchor_1.BN(args.aprRate))
        .accountsStrict({
        user: accounts.userPubkey,
        mutualBondTradeTxnVault: mutualBondTradeTxnVault,
        protocolFeeReceiver: accounts.protocolFeeReceiver,
        instructions: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
        authorizationRulesProgram: constants_1.AUTHORIZATION_RULES_PROGRAM,
        tokenProgram: token_1.TOKEN_PROGRAM_ID,
        associatedTokenProgram: token_1.ASSOCIATED_PROGRAM_ID,
        systemProgram: anchor_1.web3.SystemProgram.programId,
        rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
        metadataProgram: constants_1.METADATA_PROGRAM_PUBKEY,
        userSplTokenAccountUninitialized,
        protocolFeeReceiverSplTokenAccountUninitialized,
        collateralMint: perpetualBorrowParamsAndAccountsWithSeeds[0].tokenMint,
        metadata: nftMetadata,
        splTokenMint: splTokenMint,
        edition: editionInfo,
        rentVault,
    })
        .remainingAccounts(createAndSellBondRemainingAccounts)
        .instruction());
    const transaction = new anchor_1.web3.Transaction();
    for (const instruction of instructions)
        transaction.add(instruction);
    const signers = [];
    yield sendTxn(transaction, signers);
    return {
        instructions,
        signers,
        accounts: accountCreated,
    };
});
exports.borrowPerpetual = borrowPerpetual;
